import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalaesperaComponent } from './salaespera/salaespera.component';
import { FormComponent } from './form/form.component';
import { LoginComponent } from './login/login.component';
import { AuthenticationGuard } from './services/authentication.guard';

const routes: Routes = [
  { path: '', component: FormComponent },
  {
    path: 'enfermeria',
    component: SalaesperaComponent,
    canActivate: [AuthenticationGuard],
  },
  { path: 'login', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
